export default {
  SEAT_MOUSE_OVER: 'syos.seatMouseOver',
  SEAT_BLUR: 'syos.seatBlur',
  SEAT_FOCUS: 'syos.seatFocus',
  SEAT_CLICK: 'syos.seatClick',
  SEAT_SELECTION_LIMIT_REACHED: 'syos.seatSelectionLimitReached',
  MODAL_CLOSE: 'syos.modalClose',
  SCREEN_UPDATED: 'syos.screenUpdated',
  SEAT_MAP_ADJUST: 'syos.seatMapAdjust',
  SEAT_SELECTED: 'syos.seatSelected',
  SEAT_REMOVED: 'syos.seatRemoved',
  API_REQUEST_STARTED: 'syos.apiRequestStarted',
  API_REQUEST_COMPLETED: 'syos.apiRequestCompleted',
  API_REQUEST_ERROR: 'syos.apiRequestError',
  API_RESERVION_ATTEMPT: 'syos.apiReservationAttempt',
  API_RESERVATION_FAIL: 'syos.apiReservationFail',
  API_RESERVATION_SUCCESS: 'syos.apiReservationSuccess',
  MOBILE_ENTER: 'syos.mobileEnter',
  MOBILE_LEAVE: 'syos.mobileLeave',
  TABLET_ENTER: 'syos.tabletEnter',
  TABLET_LEAVE: 'syos.tabletLeave',
  RESERVE_SEATS: 'syos.reserveSeats',
  CART_UPDATE: 'syos.cartUpdate',
  CART_DETAILS_OPEN: 'syos.cartDetailsOpen',
  SCREENS_DATA_LOADED: 'syos.screensDataLoaded',
  SEAT_LIST_DATA_LOADED: 'syos.seatListDataLoaded',
  LEGEND_DETAILS_TOGGLE: 'syos.legendDetailsToggle',
  LEGEND_DETAILS_SHOW: 'syos.legendDetailsShow',
  LEGEND_DETAILS_HIDE: 'syos.legendDetailsHide',
};
